.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
}

.circular {
  animation: rotate 2s linear infinite;
  height: inherit;
  transform-origin: center center;
  width: inherit;
  margin: auto;
}

.path {
  stroke-dasharray: 1, 200;
  stroke-dashoffset: 0;
  animation:
    dash 1.5s ease-in-out infinite,
    color 6s ease-in-out infinite;
  stroke: $xp-ref-color-semantic-interaction; /* Material UI primary color */
  stroke-linecap: round;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@keyframes color {
  100%,
  0% {
    stroke: $xp-ref-color-semantic-interaction; /* Material UI primary color */
  }
  40% {
    stroke: $xp-ref-color-semantic-interaction; /* Material UI primary color */
  }
  66% {
    stroke: $xp-ref-color-semantic-interaction; /* Material UI primary color */
  }
  80%,
  90% {
    stroke: $xp-ref-color-semantic-interaction; /* Material UI primary color */
  }
}
